import React, { useState } from 'react';
import {Grid} from "@material-ui/core";
import Widget from "../../../components/Widget";
import DataTable from "../../../components/DataTable/DataTable";
import HeadingWithNew from "../../../components/HeadingWithNew";
import {Customers} from "../../../context/CustomersContext";
import ProgressOr from "../../../components/ProgressOr";

const ListCustomers = (props) => {
    const [customers, setCustomers] = useState(null)

    if (!customers){
        props.customersContext.fetchCustomers().then(setCustomers)
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <HeadingWithNew heading="Customers" onClick={() => props.history.push('add-customer')}/>
            </Grid>
            <Grid item xs={12}>
                <Widget disableWidgetMenu>
                    <ProgressOr showProgress={!customers} progressMessage="Fetching customers...">
                        {customers ? (
                        <DataTable
                            columns={['Name', 'Sites', 'Devices', {
                                name: 'Item',
                                options: {
                                    display: 'excluded'
                                }
                            }]}
                            filter={customer => [customer.name, customer.sites.length, customer.devices, customer]}
                            data={customers.list || []}
                            onEdit={(customer) => props.history.push({
                                pathname: 'edit-customer',
                                state: customer
                            })}
                            onDelete={(selected) => customers.remove(selected.map(customer => customer.id))}
                        />
                            ) : ""}
                    </ProgressOr>
                </Widget>
            </Grid>
        </Grid>
    )
}

export default (props) => {
    return (
        <Customers.Consumer>
            {customersContext => (
                <ListCustomers customersContext={customersContext} {...props} />
            )}
        </Customers.Consumer>
    )
}